import { loadMarketSymbols, loadMarketKlines } from './market_proxy_client';
import { createExchangeWs } from './exchange_ws_base';

export default {
    symbols: [],

    async loadExchangeInfo() {
        this.symbols = await loadMarketSymbols('kraken');
        return this.symbols;
    },
    async loadKline(symbol, tf, endTime) {
        return loadMarketKlines('kraken', symbol, tf, endTime);
    },

    // Kraken's WS ticker subscribe needs the slash-separated "wsname"
    // (e.g. "XBT/USD"), not the REST altname (e.g. "XBTUSD") used for
    // klines above — callers must pass item.wsname here, not item.symbol.
    ...createExchangeWs({
        wsUrl: 'wss://ws.kraken.com',
        buildSubscribe: pairs => JSON.stringify({ event: 'subscribe', pair: pairs, subscription: { name: 'ticker' } }),
        buildUnsubscribe: pairs => JSON.stringify({ event: 'unsubscribe', pair: pairs, subscription: { name: 'ticker' } }),
    }),
};
